import { EventStatus } from '@models/api/event';
import { getErrorStatus } from '@utils/errorDetection';
import { readAxiosDetailCode } from '@utils/axiosErrorDetail';

/** True for an event that calendar sync marked cancelled. */
export const isEventCancelled = (event: { status?: string | null }): boolean =>
  event.status === EventStatus.cancelled;

/**
 * True for the 409 the backend answers to a new Going or check-in on a cancelled event: the
 * page the person is on is stale, and the refetch shows them the cancelled state.
 */
export const isEventCancelledError = (err: unknown): boolean =>
  getErrorStatus(err) === 409 && readAxiosDetailCode(err) === 'EVENT_CANCELLED';
